module.exports = {
    cdnBaseUrl: FINN.travel.cdnBaseUrl || '',
    contextPath: FINN.travel.contextPath || '',
};
